export default [{
  "type": "PrivacyManager",
  "name": "Privacy Manager",
  "settings": {},
  "children": []
}];